var styles = {
  "ScrollContainer": "Polaris-IndexTable-ScrollContainer"
};

export { styles as default };
